import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {Button} from "primeng/button";
import {Dialog} from "primeng/dialog";
import {Fluid} from "primeng/fluid";
import {InputNumber} from "primeng/inputnumber";
import {PrimeTemplate} from "primeng/api";
import {Select} from "primeng/select";
import {Forecast} from '../forecast/forecast';
import {Observable} from 'rxjs';
import {SubsidiaryCollection} from '../subsidiary/subsidiary-collection';
import {SubsidiaryService} from '../subsidiary/subsidiary.service';
import {Subsidiary} from '../subsidiary/subsidiary';
import {FormsModule} from '@angular/forms';
import {ForecastDetailService} from '../forecast-detail/forecast-detail.service';

@Component({
  selector: 'app-add-forecast-detail',
    imports: [
        AsyncPipe,
        Button,
        Dialog,
        Fluid,
        InputNumber,
        PrimeTemplate,
        Select,
        FormsModule
    ],
  templateUrl: './add-forecast-detail.html',
  styleUrl: './add-forecast-detail.scss',
})
export class AddForecastDetail implements OnInit {

    @Input() public forecast!: Forecast;
    @Input() public visible = false;
    @Output() protected visibleChange = new EventEmitter<boolean>();
    @Output() protected saved = new EventEmitter<void>();

    protected subsidiaries$!: Observable<SubsidiaryCollection>;
    protected selectedSubsidiary!: Subsidiary;
    protected forecastDetailQuantity = 0;

    constructor(
        private subsidiaryService: SubsidiaryService,
        private forecastDetailService: ForecastDetailService,
    ) {}

    ngOnInit(): void {
        this.subsidiaries$ = this.subsidiaryService.getAll();
    }

    protected closeModal(): void {
        this.visibleChange.emit(false);
    }

    protected saveNewForecastDetail(): void {
        this.forecastDetailService.createNewForecastDetail(
            this.forecastDetailQuantity,
            this.selectedSubsidiary,
            this.forecast
        ).subscribe(() => {
            this.saved.emit();
            this.closeModal();
        });
    }
}
